<template>
  <div class="field">
    <div class="control">
      <ZoomConnect
        :is-connected="isConnected"
      />
    </div>
    <div class="control mt-3">
      <button
        v-if="isConnected"
        class="button is-info is-small"
        @click="showMeetingList = true"
      >
        Browse Zoom Meetings
      </button>
    </div>

    <StakeModal v-model="showMeetingList">
      <ZoomMeetingList @uploaded="closeAndRefresh" />
    </StakeModal>
  </div>
</template>


<script>
import ZoomConnect from '@features/meetings/components/ZoomConnect.vue';
import ZoomMeetingList from '@features/meetings/components/ZoomMeetingList.vue';
import StakeModal from '@stakeui/StakeModal.vue';

import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
import { mapStores } from 'pinia';

export default {
  name: 'ZoomWrapper',
  components: {
    ZoomConnect,
    ZoomMeetingList,
    StakeModal,
  },
  props: [/* Inputs */],
  data() {
    return {
      showMeetingList: false,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    headers() {
      return {
        'X-CSRFToken': this.$root.$data.csrfToken,
        'Content-Type': 'application/json',
      };
    },
    ...mapStores(useAdvisorStore),
    isConnected() {
      const connections = this.advisorStore.activeOAuthConnections;
      if (!connections) return undefined;
      return connections['Zoom'] ? true : false;
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {

  },
  mounted() {},
  updated() {},
  methods: {
    closeAndRefresh() {
      this.showMeetingList = false;
      this.$emit('refresh');
      this.$emit('uploaded');
    },
  },
};
</script>


  <style scoped>
  .field {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  </style>
